import React from "react";
import { Snackbar, Alert, Typography, Box } from "@mui/material";

interface OneSnackbarProps {
  error?: string | string[] | null;
  success?: string | null;
  onClose: () => void;
  autoHideDuration?: number;
}

const OneSnackbar: React.FC<OneSnackbarProps> = ({
  error,
  success,
  onClose,
  autoHideDuration = 6000,
}) => {
  const open = !!error || !!success;
  const severity = error ? "error" : "success";
  const message = error ?? success;

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity={severity as "error" | "success"}
        sx={{ width: "100%" }}
      >
        {Array.isArray(message) ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {message.map((msg, index) => (
              <Typography key={index} variant="body2">
                {msg}
              </Typography>
            ))}
          </Box>
        ) : (
          message
        )}
      </Alert>
    </Snackbar>
  );
};

export default OneSnackbar;
